<template>
  <div class="small-popup">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../styles/variables";

.small-popup {
  position: absolute;
  right: 0;
  top: 0;
  background: $color-white;
  color: $color-medium-grey;
  box-shadow: 0 2px 4px rgba(153, 153, 153, 0.4);
  border: 1px solid $color-grey;
  border-radius: 4px;
  font-size: 13px;
  z-index: 10;
  padding: 12px 16px;
}
</style>
